// @flow

import type { PendingIncomingPayment } from './types';
import { getGateway } from '@tectonics/prs/gateway';

export function getGatewayPaymentCode(incomingPayment: PendingIncomingPayment): ?string {
  const gateway = getGateway(incomingPayment);
  return gateway['payment_code'];
}

export function getSafeGatewayPaymentCode(incomingPayment: PendingIncomingPayment): string {
  const code = getGatewayPaymentCode(incomingPayment);
  if (!code) {
    throw new Error('getSafeGatewayPaymentCode - there is no payment code in the incoming payment');
  }
  return code;
}
